import {Directive } from "@angular/core"

@Directive({
    selector: "[rxTabContent]"
})
export class RxTabContentDirective {
}